export default "__VITE_ASSET__392363ed__"